// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader-module--loader--3RxtS","loaderAnim":"loader-module--loaderAnim--YFeK_","slideLeft":"loader-module--slideLeft--1UxH-","floating":"loader-module--floating--3dD6q"};